import { Component, OnInit, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import * as moment from 'moment';
import { FollowUpService } from '../../../services/index';

@Component({
    selector: 'follow-up-calendar-modal',
    templateUrl: './followUpCalendarModal.component.html',
    styles: [`
        .fuc-modal-header {
            background: linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%);
            color: #fff;
            padding: 14px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
        }
        .fuc-modal-header h4 {
            margin: 0;
            font-size: 16px;
            font-weight: bold;
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .fuc-close-btn {
            background: transparent;
            border: none;
            color: #fff;
            font-size: 20px;
            cursor: pointer;
            line-height: 1;
            opacity: 0.85;
        }
        .fuc-close-btn:hover { opacity: 1; }
        .fuc-body {
            padding: 16px 20px;
            background: #f8fafc;
            max-height: 80vh;
            overflow-y: auto;
        }
        .fuc-nav-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #fff;
            border: 1px solid #cbd5e1;
            border-radius: 6px;
            padding: 8px 16px;
            margin-bottom: 14px;
        }
        .fuc-month-title {
            font-size: 16px;
            font-weight: bold;
            color: #1e3a8a;
        }
        .fuc-btn-nav {
            background: #f1f5f9;
            border: 1px solid #cbd5e1;
            color: #334155;
            padding: 4px 12px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
        }
        .fuc-btn-nav:hover { background: #e2e8f0; }
        .fuc-cal-grid {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            background: #fff;
            border: 1px solid #cbd5e1;
            border-radius: 6px;
            overflow: hidden;
            margin-bottom: 16px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.04);
        }
        .fuc-day-hdr {
            background: #f1f5f9;
            padding: 8px 4px;
            text-align: center;
            font-size: 11px;
            font-weight: bold;
            color: #475569;
            border-right: 1px solid #e2e8f0;
            border-bottom: 1px solid #cbd5e1;
        }
        .fuc-day-hdr:last-child { border-right: none; }
        .fuc-cal-cell {
            min-height: 72px;
            border-right: 1px solid #e2e8f0;
            border-bottom: 1px solid #e2e8f0;
            padding: 6px;
            position: relative;
            background: #fff;
            cursor: default;
            transition: background 0.15s ease;
        }
        .fuc-cal-cell:nth-child(7n) { border-right: none; }
        .fuc-cal-cell.other-month {
            background: #f8fafc;
            opacity: 0.45;
        }
        .fuc-cal-cell.today {
            background: #eff6ff;
            border: 2px solid #3b82f6;
        }
        .fuc-cal-cell.selected {
            background: #e0e7ff;
            border: 2px solid #4338ca;
        }
        .fuc-cal-cell.past-day {
            background: #f8fafc;
            opacity: 0.55;
            cursor: default;
        }
        .fuc-cal-cell.has-calls {
            cursor: pointer;
        }
        .fuc-cal-cell.has-calls:hover {
            background: #f0fdf4;
        }
        .fuc-cell-day {
            font-size: 12px;
            font-weight: bold;
            color: #334155;
            margin-bottom: 4px;
        }
        .fuc-cell-badge {
            background: #2563eb;
            color: #fff;
            padding: 3px 6px;
            border-radius: 4px;
            font-size: 10px;
            font-weight: bold;
            text-align: center;
            display: inline-block;
            box-shadow: 0 1px 3px rgba(37,99,235,0.3);
        }
        .fuc-cell-badge.today-badge {
            background: #10b981;
        }
        .fuc-entries-card {
            background: #fff;
            border: 1px solid #cbd5e1;
            border-radius: 6px;
            padding: 14px;
            margin-bottom: 14px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.04);
        }
        .fuc-entries-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            border-bottom: 1px solid #e2e8f0;
            padding-bottom: 8px;
        }
        .fuc-entries-title {
            font-size: 13px;
            font-weight: bold;
            color: #1e3a8a;
        }
        .fuc-table {
            width: 100%;
            table-layout: fixed;
            border-collapse: collapse;
            font-size: 12px;
        }
        /* Reset global _layout.scss: tbody{display:block} + thead,tbody tr{display:table} */
        .fuc-table thead { display: table-header-group !important; }
        .fuc-table tbody { display: table-row-group !important; height: auto !important; overflow: visible !important; }
        .fuc-table thead tr,
        .fuc-table tbody tr { display: table-row !important; width: 100% !important; }
        .fuc-table th {
            background: #f1f5f9;
            color: #334155;
            padding: 8px 10px;
            text-align: left;
            font-size: 11px;
            font-weight: bold;
            border-bottom: 2px solid #cbd5e1;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .fuc-table td {
            padding: 8px 10px;
            border-bottom: 1px solid #e2e8f0;
            color: #334155;
            overflow: hidden;
            word-break: break-word;
        }
        .fuc-table tr:hover td { background: #f8fafc; }
        .fuc-table tr.selected-row td { background: #eff6ff; }
        .fuc-modal-footer {
            background: #fff;
            border-top: 1px solid #cbd5e1;
            padding: 12px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom-left-radius: 6px;
            border-bottom-right-radius: 6px;
        }
        .fuc-btn-apply {
            background: #16a34a;
            color: #fff;
            border: none;
            padding: 7px 18px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
            box-shadow: 0 2px 4px rgba(22,163,74,0.3);
        }
        .fuc-btn-apply:hover:not(:disabled) { background: #15803d; }
        .fuc-btn-apply:disabled { opacity: 0.5; cursor: not-allowed; }
        .fuc-btn-close {
            background: #f1f5f9;
            border: 1px solid #cbd5e1;
            color: #475569;
            padding: 7px 16px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
        }
        .fuc-btn-close:hover { background: #e2e8f0; }
    `]
})
export class FollowUpCalendarModalComponent implements OnInit {
    tabParams: string = 'Unsold';
    branch_id: string = '';
    employee_id: string = '';
    filterData: any = {};

    applyEntriesEvent = new EventEmitter<any>();

    currentMonthMoment: any = moment();
    monthTitle: string = '';
    calendarDays: any[] = [];
    callCountsMap: { [key: string]: number } = {};
    isLoadingCalendar: boolean = false;

    selectedDate: string = '';
    selectedDateDisp: string = '';
    dateEntries: any[] = [];
    isLoadingEntries: boolean = false;
    selectAllChecked: boolean = false;

    constructor(
        public bsModalRef: BsModalRef,
        private followUpService: FollowUpService
    ) {}

    ngOnInit() {
        if (this.tabParams && this.tabParams !== 'Unsold') {
            this.loadCalendarMonth();
        }
    }

    initModal(tabParams: string, branch_id: string, employee_id: string, filterData: any) {
        this.tabParams = tabParams || 'Unsold';
        this.branch_id = branch_id || '';
        this.employee_id = employee_id || '';
        this.filterData = filterData || {};
        this.loadCalendarMonth();
    }

    loadCalendarMonth() {
        this.monthTitle = this.currentMonthMoment.format('MMMM YYYY');
        this.isLoadingCalendar = true;
        this.callCountsMap = {};

        let params: any = {
            from_page: this.tabParams || 'Unsold',
            month: this.currentMonthMoment.format('M'),
            year: this.currentMonthMoment.format('YYYY'),
            branch_id: this.branch_id || '',
            employee_id: this.employee_id || ''
        };

        if (this.filterData) {
            if (this.filterData['reference']) params['reference'] = this.filterData['reference'];
            if (this.filterData['search_data']) params['search_data'] = this.filterData['search_data'];
            if (this.filterData['important']) params['important'] = this.filterData['important'];
            if (this.filterData['willing']) params['willing'] = this.filterData['willing'];
            if (this.filterData['districts']) params['districts'] = this.filterData['districts'];
            if (this.filterData['fol_id']) params['folupstatus'] = this.filterData['fol_id'];
            if (this.filterData['fol_status']) params['fol_status'] = this.filterData['fol_status'];
            if (this.filterData['promo_name']) params['promo_name'] = this.filterData['promo_name'];
            if (this.filterData['promo_type']) params['promo_type'] = this.filterData['promo_type'];
            if (this.filterData['unsold_feedback']) params['unsold_feedback'] = this.filterData['unsold_feedback'];
            if (this.filterData['sold_feedback']) params['sold_feedback'] = this.filterData['sold_feedback'];
            if (this.filterData['unsold_description_id']) params['unsold_description_id'] = this.filterData['unsold_description_id'];
        }

        let that = this;
        this.followUpService.getFutureCalendarCounts(params)
            .then((res: any) => {
                that.isLoadingCalendar = false;
                if (res && res.data && res.data.length) {
                    res.data.forEach((item: any) => {
                        let dateKey = item.date_ymd || item.date;
                        that.callCountsMap[dateKey] = parseInt(item.call_count, 10) || 0;
                    });
                }
                that.generateCalendarGrid();
            })
            .catch(() => {
                that.isLoadingCalendar = false;
                that.generateCalendarGrid();
            });
    }

    generateCalendarGrid() {
        this.calendarDays = [];
        const startOfMonth = moment(this.currentMonthMoment).startOf('month');
        const endOfMonth = moment(this.currentMonthMoment).endOf('month');
        const startDayOfWeek = startOfMonth.day(); // 0 (Sun) to 6 (Sat)
        const daysInMonth = startOfMonth.daysInMonth();
        const todayStr = moment().format('YYYY-MM-DD');

        // Padding previous month days
        const prevMonth = moment(startOfMonth).subtract(1, 'month');
        const prevMonthDays = prevMonth.daysInMonth();
        for (let i = startDayOfWeek - 1; i >= 0; i--) {
            const dayNum = prevMonthDays - i;
            const dateStr = prevMonth.clone().date(dayNum).format('YYYY-MM-DD');
            this.calendarDays.push({
                dayNum: dayNum,
                dateStr: dateStr,
                isCurrentMonth: false,
                isToday: false,
                isPast: true,
                callCount: 0
            });
        }

        // Current month days
        for (let day = 1; day <= daysInMonth; day++) {
            const curDateMoment = startOfMonth.clone().date(day);
            const dateStr = curDateMoment.format('YYYY-MM-DD');
            const isToday = (dateStr === todayStr);
            const isPast = curDateMoment.isBefore(moment(), 'day');

            // Requirement 1 & 2: Previous date count not need to show. Show today and future date count.
            let count = 0;
            if (!isPast || isToday) {
                count = this.callCountsMap[dateStr] || 0;
            }

            this.calendarDays.push({
                dayNum: day,
                dateStr: dateStr,
                dispDate: curDateMoment.format('DD-MM-YYYY'),
                isCurrentMonth: true,
                isToday: isToday,
                isPast: isPast && !isToday,
                callCount: count
            });
        }

        // Padding next month days to complete 7-day grid rows (35 or 42 cells)
        const totalCells = this.calendarDays.length;
        const targetCells = totalCells > 35 ? 42 : 35;
        const remaining = targetCells - totalCells;
        const nextMonth = moment(startOfMonth).add(1, 'month');
        for (let day = 1; day <= remaining; day++) {
            const dateStr = nextMonth.clone().date(day).format('YYYY-MM-DD');
            this.calendarDays.push({
                dayNum: day,
                dateStr: dateStr,
                isCurrentMonth: false,
                isToday: false,
                isPast: false,
                callCount: 0
            });
        }
    }

    prevMonth() {
        this.currentMonthMoment = moment(this.currentMonthMoment).subtract(1, 'month');
        this.selectedDate = '';
        this.dateEntries = [];
        this.loadCalendarMonth();
    }

    nextMonth() {
        this.currentMonthMoment = moment(this.currentMonthMoment).add(1, 'month');
        this.selectedDate = '';
        this.dateEntries = [];
        this.loadCalendarMonth();
    }

    goToToday() {
        this.currentMonthMoment = moment();
        this.selectedDate = '';
        this.dateEntries = [];
        this.loadCalendarMonth();
    }

    onSelectDay(day: any) {
        if (!day.isCurrentMonth || day.isPast) { return; }
        this.selectedDate = day.dateStr;
        this.selectedDateDisp = day.isToday ? `${day.dispDate} (Today - All Pending Calls)` : day.dispDate;
        this.selectAllChecked = false;
        this.fetchEntriesForDate(day.dateStr);
    }

    fetchEntriesForDate(dateStr: string) {
        this.isLoadingEntries = true;
        this.dateEntries = [];

        let params: any = {
            date: dateStr,
            from_page: this.tabParams || 'Unsold',
            branch_id: this.branch_id || '',
            employee_id: this.employee_id || ''
        };

        if (this.filterData) {
            if (this.filterData['reference']) params['reference'] = this.filterData['reference'];
            if (this.filterData['search_data']) params['search_data'] = this.filterData['search_data'];
            if (this.filterData['important']) params['important'] = this.filterData['important'];
            if (this.filterData['willing']) params['willing'] = this.filterData['willing'];
            if (this.filterData['districts']) params['districts'] = this.filterData['districts'];
            if (this.filterData['fol_id']) params['folupstatus'] = this.filterData['fol_id'];
            if (this.filterData['fol_status']) params['fol_status'] = this.filterData['fol_status'];
            if (this.filterData['promo_name']) params['promo_name'] = this.filterData['promo_name'];
            if (this.filterData['promo_type']) params['promo_type'] = this.filterData['promo_type'];
            if (this.filterData['unsold_feedback']) params['unsold_feedback'] = this.filterData['unsold_feedback'];
            if (this.filterData['sold_feedback']) params['sold_feedback'] = this.filterData['sold_feedback'];
            if (this.filterData['unsold_description_id']) params['unsold_description_id'] = this.filterData['unsold_description_id'];
        }

        let that = this;
        this.followUpService.getEntriesByDate(params)
            .then((res: any) => {
                that.isLoadingEntries = false;
                if (res && res.data && res.data.length) {
                    that.dateEntries = res.data.map((item: any) => {
                        item.selected = false;
                        return item;
                    });
                }
            })
            .catch(() => {
                that.isLoadingEntries = false;
            });
    }

    onToggleSelectAll(checked: boolean) {
        this.selectAllChecked = checked;
        this.dateEntries.forEach(e => e.selected = checked);
    }

    onEntrySelectChange() {
        const total = this.dateEntries.length;
        const selected = this.dateEntries.filter(e => e.selected).length;
        this.selectAllChecked = (total > 0 && total === selected);
    }

    getSelectedCount(): number {
        return this.dateEntries.filter(e => e.selected).length;
    }

    applySelection() {
        const selectedList = this.dateEntries.filter(e => e.selected);
        if (selectedList.length === 0) {
            return;
        }
        this.applyEntriesEvent.emit(selectedList);
        this.bsModalRef.hide();
    }

    closeModal() {
        this.bsModalRef.hide();
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/followUp/followUpCalendarModal.component.ts